<template>
  <div>
    <div class="personal" >
       <h3>
         机构信息
       </h3>
       
        <el-form 
        
        label-position="left"
        :inline="false"
        label-width="auto"
        :model="ruleForm" 
        :rules="rules"
        ref="ruleForm"
        >
        <el-form-item label="机构名称" prop="organname">
              <el-input v-model="ruleForm.organname"></el-input>
        </el-form-item>

        <el-form-item label="机构简称" prop="organesayname">
              <el-input v-model="ruleForm.organesayname"></el-input>
        </el-form-item>

        <el-form-item label="营业执照" >
          <!-- enctype="multipart/form-data" -->
          <div @click="uploadimgselect('cread')">
            <el-upload
              ref="upload"
              class="avatar-uploader"
              action="http://www.cubeassociation.net/prod-api/common/uploadImg"

              :limit="1"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :on-error="afterAvatarErrorOne"
              >
              <!-- :http-request="uploadimage" -->
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="机构LOGO" >
          <div @click="uploadimgselect('logo')">
              <el-upload
              ref="uploadlogo"
              class="avatar-uploader"
              action="http://www.cubeassociation.net/prod-api/common/uploadImg"
              :limit="1"
              :show-file-list="false"
              :before-upload="logobeforeAvatarUpload"
              :on-success="logohandleAvatarSuccess"
              :on-error="afterAvatarErrorTwo"
              >
              <img v-if="logoimageUrl" :src="logoimageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>

         <el-form-item label="机构地址">
          <el-row>
            <el-col :span="7">
              <el-form-item prop="Provincevalue">
                <el-select  clearable v-model="ruleForm.Provincevalue" placeholder="省" @change="provinceChange($event)">
                  <el-option
                    v-for="item in form.provinceList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>  
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="7">

              <el-form-item prop="cityvalue">
                <el-select  clearable v-model="ruleForm.cityvalue" placeholder="市"  @change="cityChange($event)" >
                  <el-option
                    v-for="item in form.cityList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item> 

            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="7">

              <el-form-item prop="countyvalue">
                <el-select clearable v-model="ruleForm.countyvalue" required placeholder="区">
                  <el-option
                    v-for="item in form.countyList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>

            </el-col>
            </el-row>
            <el-row >
              <el-form-item prop="address">
                <el-input 
                v-model="ruleForm.address"
                placeholder="请填写详细地址">
                </el-input>
              </el-form-item>
            </el-row>  
      </el-form-item>


          <el-form-item label="联系人姓名" prop="realName">
              <el-input v-model="ruleForm.realName"></el-input>
          </el-form-item>

          <el-form-item label="联系人手机号" prop="mobile">
            <el-input
             v-model="ruleForm.mobile"
             autocomplete="off">
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button style="background-color:#F1F0F6;color:#333333;margin-right:30px;margin-left:30px" @click="closeorganauth">关闭</el-button>
            <el-button style="background-color:#2EAE95;color:#FFFFFF" @click="submitForm('ruleForm')">确定</el-button>
          </el-form-item>
          
    </el-form>
    </div>
      
  </div>
</template>

<script>
import request from '../utils/request';
import {mapGetters} from "vuex"
export default {
   data() {
      var validatemobile = (rule, value, callback) => {
          let str = /^[1][3,5,7,8][0-9]{9}$/
          let strtwo = /^(([0-9]{11})|([0-9]{3}\-[0-9]{8})|([0-9]{4}\-[0-9]{7}))$/
          if (value === '') {
            callback(new Error('请输入手机号'));
          } 
          if (str.test(value) || strtwo.test(value)) {
            callback();
          }
          else {
            callback(new Error('请输入正确的手机号')); 
          } 
      };
      var validaterealName = (rule, value, callback) => {
        // let str = /^[a-zA-Z\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/ //用于校验“中英文”姓名
        let str = /[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,4}$/ //仅用于校验中文姓名
        if (value === '') {
            callback(new Error('请输入姓名'));
          }else if(str.test(value) == false){
            callback(new Error('请输入真实姓名'));
          }else if(value.length > 4){
            callback(new Error('请输入真实姓名'));  //仅用于校验中文姓名
          }
          else {
            callback();
          }
      };

      var validateorganname = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入机构名称'));
          }
          else {
            callback();
          } 
      };
      var validateorganesayname = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入机构简称'));
        }else if(value.length > 5){
          callback(new Error('机构简称最多仅可输入5个字符'));
        }
        else {
            callback();
        } 
      };

      var validateaddress = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请输入详细地址'));
        } 
        else {
            callback();
          } 
      };
      return {
        // personInfo:{},  //用户信息 (用于数据回显)
        imageUrl: "",//营业执照上传成功返回的src地址
        logoimageUrl:"",//机构logo上传成功返回的src地址
        
        ruleForm: {
          organname:"",
          organesayname:"",
          mobile: '',
          realName:"",

          uploadimg:"",//图片上传请求后 返回的img地址（用于表单提交）
          uploadimglogo:"",//图片上传请求后 返回的img地址（用于表单提交）

          Provincevalue: '', //省
          cityvalue: '', //市
          countyvalue: '', //区
          address: '', // 详细地址
        },
        rules: {
          organname:[{  validator: validateorganname, trigger: 'blur',}],
          organesayname:[{  validator: validateorganesayname, trigger: 'blur',}],
          mobile: [
            { validator: validatemobile, trigger: 'blur' }
          ],
          realName: [
            { validator: validaterealName, trigger: 'blur' }
          ],
          address: [
            {validator: validateaddress,trigger : 'blur',} 
          ],
        },
        // 省市区
        form:{
          provinceList:[],
          cityList:[],
          countyList:[],
          },
          // 联动中转数组
          CITY:[],
          XIAN:[],
        
      }
  },
    created(){
      // 调用获取信息接口 根据登录成功返回的id 请求信息 (用于数据回显)
      // 调用获取 省级列表请求事件
      this.getprovincelist()
    },
    computed:{
      //(用于认证完成重新获取数据)
      ...mapGetters([
        "organInfoid", //机构id
      ])
    },
    methods:{
      // 关闭按钮
      closeorganauth(){
        // 关闭弹层  子传父 
          this.$emit("closeorganauth",false)
      },
      // 打开上传文件选择器前清除上一次选择的文件
      uploadimgselect(type){
        if(type == "cread"){
           this.$refs.upload.clearFiles()
        }else{
          this.$refs.uploadlogo.clearFiles()
        }
      },

      // 营业执照上传赋值事件
      handleAvatarSuccess(res, file) {
        // 将上传的文件 返回的对象中的地址赋给图片src 用于展示
        this.imageUrl = URL.createObjectURL(file.raw);
        // 赋值给表单 用于发请求
        this.ruleForm.uploadimg = file.response.data.imgPath
        // console.log(file)
        console.log(file.response.data.imgPath)
      },
      // 机构logo上传赋值事件
      logohandleAvatarSuccess(res, file) {
        // 上传成功返回的图片地址赋值给data数据 用于展示
        this.logoimageUrl = URL.createObjectURL(file.raw);
        // 赋值给表单 用于发请求
        this.ruleForm.uploadimglogo = file.response.data.imgPath
        // console.log(file)
        console.log(file.response.data.imgPath)
      },
      // 营业执照上传判断事件
      beforeAvatarUpload(file) {
        // 上传图片
        const isJPG = file.type === 'image/jpeg' || file.type === "image/png" 
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isJPG) {
          this.$message.error('上传的图片只能是 JPG或者Png格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传的图片大小不能超过 2MB!');
        }
        // return isJPG && isLt2M;
        return isJPG && isLt2M
      },
      // 机构logo上传判断事件
      logobeforeAvatarUpload(file) {
        // 上传图片
        const isJPG = file.type === 'image/jpeg' || file.type === "image/png" 
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        // return isJPG && isLt2M;
        return isJPG && isLt2M
      },
      // 删除文件事件
      // del(type){
      //     if(type === 'one'){
      //       this.$refs.upload.clearFiles()
      //       this.imageUrl = ""
      //     }else{
      //       this.$refs.uploadlogo.clearFiles()
      //       this.logoimageUrl = ""
      //     }
      // },

      // 请求机构信息逻辑
      async getorganinfo(){
        const {data} =  await request({
          url:"/customer/OrgUserInfo/getInfo",
          method:"POST",
          params:{
            orgId : this.organInfoid
          }
        })
        console.log("认证完成获取最新的机构信息成功")
        console.log(data.data)
        // 将数据存到vuex中(覆盖掉原来登录时存储的数据对象)
        this.$store.commit("updateorganInfo",data.data || {} )
      },
      // 表单提交逻辑
      submitForm(formName) {
        // console.log("开始保存")
        // 判断是否上传了图片
        if(this.imageUrl == "" || this.logoimageUrl == ""){
          this.$alert('请完善"营业执照"或"机构LOGO"',  {
            confirmButtonText: '确定',
            center:true,
            confirmButtonClass:"el-button--success",
          });
          return 
        }
        // 判断是否选择了地址
        if(this.ruleForm.Provincevalue === "" || this.ruleForm.cityvalue === "" || this.ruleForm.countyvalue === "" ){
            this.$alert('请完善地址信息',  {
                    confirmButtonText: '确定',
                    center:true,
                    confirmButtonClass:"el-button--success",
            });
            return
        }  
        this.$refs[formName].validate( async (valid) => {
            console.log("开始校验")
            if (valid) {
            console.log("校验成功,发起请求")
            // 校验成功 发起请求 传送表单数据
            const {data} = await request({
                method:"POST",
                url: `/customer/OrgUserInfo/modifyInfo`,
                params:{
                    id:this.organInfoid,
                    orgName: this.ruleForm.organname,
                    orgSubName: this.ruleForm.organesayname,

                    creditImg: this.ruleForm.uploadimg,
                    logoImg: this.ruleForm.uploadimglogo,

                    provinceName: this.ruleForm.Provincevalue,
                    cityName: this.ruleForm.cityvalue,
                    countyName: this.ruleForm.countyvalue,
                    address: this.ruleForm.address,

                    contactName: this.ruleForm.realName,
                    contactPhone: this.ruleForm.mobile,
                }
              })
              console.log(data)
                if(data.code == 200){
                  // 提交请求成功
                  await this.$alert('提交成功',  {
                      confirmButtonText: '确定',
                      center:true,
                      confirmButtonClass:"el-button--success",
                  });
                  // 使用id获取最新的机构信息 存入vuex（覆盖原数据  就实现了响应式的是否显示state状态）
                  this.getorganinfo()
                  // 关闭弹层 子传父
                  this.$emit("closeorganauth",false)

                }else{
                  await this.$alert('提交失败',  {
                      confirmButtonText: '确定',
                      center:true,
                      confirmButtonClass:"el-button--success",
                  });
                }
            } else {
              // 校验失败
              console.log("校验失败");
              return false;
            }
        });  
      },

      //上传失败事件（营业执照）
      afterAvatarErrorOne(){
        this.$message.error("上传失败,请重试或选择其他图片")
        console.log("错误信息", err )
      },
      //上传失败事件（机构logo）
      afterAvatarErrorTwo(){
        this.$message.error("上传失败,请重试或选择其他图片")
        console.log("错误信息", err )
      },
      

      // 请求省级列表
      async getprovincelist(){
        await request({
              method:"get",
              url:"https://restapi.amap.com/v3/config/district?parameters",
              params:{
                  key:"3a708a4ef5e3af28694b1c861985a5ce",
                  keyWords:"中国",
                  subdistrict:3
              }
        }).then((res)=>{
            this.form.provinceList = res.data.districts[0].districts  /* 省*/
              /* 进行遍历赋值*/
              /* 市区和县区*/
            let newProvince = this.form.provinceList
            for(let i = 0; i < newProvince.length; i++){              /* 省级*/
                for(let j = 0; j < newProvince[i].districts.length; j++){       /* 市级*/
                    let city = newProvince[i].districts[j].name
                    this.CITY.push({id:j+1,name:city,code:i+1})
                    for(let k = 0;k<newProvince[i].districts[j].districts.length; k++){/* 县级*/
                        let xian = newProvince[i].districts[j].districts[k].name
                          this.XIAN.push({id:k+1,name:xian,code:j+1,cityCountyName:city})
                    }
                }
            }
            for(let m = 0; m < newProvince.length;m++){
                newProvince[m] = {...newProvince[m],...{code:m+1}}
            }
            this.form.provinceList = newProvince
            })
        },
        // 省级列表数据改变时触发
        provinceChange(that){
          // 清空市、区下拉框值
            this.ruleForm.cityvalue = ""
            this.ruleForm.countyvalue = ""
            // 根据选中省，匹配市
            let cityCode = 0
            let newCityArry = []
            this.form.provinceList.forEach((item,index)=>{
                if(item.name == that){
                    cityCode = item.code
                }
            })
              // console.log(cityCode)
            if(cityCode){
                this.form.cityList = []
                this.CITY.forEach((item,index)=>{
                    if(item.code == cityCode){
                        this.form.cityList.push(item)
                    }
                })  /* 市匹配成功*/
            }
        },
        // 市级列表数据改变时触发
        cityChange(that){
           this.ruleForm.countyvalue = ""
           
          let countyCode = 0
          let cityname = ''
          let newCountyArry = []
          this.form.cityList.forEach((item,index)=>{
              if(item.name == that){
                  countyCode = item.id
                  cityname = item.name
              }
          })
          if(countyCode){
              this.form.countyList = []
              this.XIAN.forEach((item,index)=>{
                  if(item.code == countyCode && item.cityCountyName == cityname){
                      this.form.countyList.push(item)
                  }
              })
          }
        },      
      
    },

}
</script>

<style lang="less" scoped>
.personal h3 {
  font-size: 30px;
  text-align: left;
  margin-bottom: 20px;
}
/deep/.el-form-item{
  margin-bottom: 20px;
}
/deep/.el-form-item:last-child{
  text-align: left;
}
/deep/.el-form-item__label{
  font-weight: bold;
}
/deep/.avatar-uploader{
  height: 88px;
}
// 图片上传↓↓
/deep/  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
/deep/   .avatar-uploader {
  text-align: left;
}
/deep/   .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
/deep/   .avatar-uploader-icon {
    font-size: 20px;
    color: #8c939d;
    width: 88px;
    height: 88px;
    line-height: 88px;
    text-align: center;
  }
/deep/   .avatar {
    width: 88px;
    height: 88px;
    display: block;
  }

  // 图片上传↑↑
/deep/.el-input__inner {
  background-color:#F1F0F6 ;
}
/* el-单选框样式 */
  /* 单选框选中后的字体颜色 */
/deep/  .el-radio__input.is-checked  .el-radio__label {
    color: #333333 !important;
  }
  /* 单选框选中后小圆点的颜色 */
/deep/  .el-radio__input.is-checked .el-radio__inner {
    background: #2EAE95 !important;
    border-color: #2EAE95 !important;
  }

// 下拉框样式
/deep/ .el-row:first-child{
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
}
</style>